import { Wordmark } from "./Wordmark";
import { useContent, text } from "../../hooks/useContent";

// The inner meridian splash stage (rings + arcs + pips + wordmark lockup).
// Presentational only; styling lives in the `ld-*` CSS classes. Shared by the
// boot Loader, the language-switch overlay, and the Design Kit showcase.
export function SplashStage() {
  const { data: content } = useContent();
  return (
    <div className="ld-meridian">
      <div className="stage">
        <div className="ld-ring" />
        <div className="ld-ring r2" />
        <div className="ld-ring r3" />
        <div className="arc" />
        <div className="arc a2" />
        <div className="pip-wrap">
          <div className="pip top" />
          <div className="pip bottom" />
        </div>
        <div className="lockup">
          <Wordmark size="md" taglineTitle={text(content, "brand.tagline") || undefined} />
        </div>
      </div>
    </div>
  );
}
